import { Tooltip as TTooltip, styled } from 'tamagui'

const GLASS_BG = 'rgba(105, 102, 118, 0.8)'
const GLASS_BORDER = 'rgba(105, 102, 118, 1.0)'
const ARROW_BG = 'rgba(105, 102, 118, 0.7)'

const BACKDROP_STYLE = {
  backdropFilter: 'blur(8px) saturate(250%)',
  WebkitBackdropFilter: 'blur(8px) saturate(250%)',
}

const TooltipContent = styled(TTooltip.Content, {
  animation: 'fastSpring',
  enterStyle: { x: 0, y: 5, opacity: 0, scale: 0.9 },
  exitStyle: { x: 0, y: 5, opacity: 0, scale: 0.9 },
  scale: 1,
  x: 0,
  y: 0,
  opacity: 1,
  borderColor: GLASS_BORDER,
  backgroundColor: GLASS_BG,
  style: BACKDROP_STYLE,
} as const)

const TooltipArrow = styled(TTooltip.Arrow, {
  borderColor: GLASS_BORDER,
  backgroundColor: ARROW_BG,
  style: BACKDROP_STYLE,
} as const)

export const Tooltip = Object.assign(TTooltip, {
  Content: TooltipContent,
  Arrow: TooltipArrow,
  Trigger: TTooltip.Trigger,
})
